/**
 * Bersaglio del lampeggio argento, se all'ultimo controllo è arrivato un NUOVO spostamento (l'array
 * è cresciuto); `null` altrimenti. Logica pura e testabile a parte perché l'effetto che la chiama deve
 * reagire solo alla lunghezza dell'array (vedi MatchPage.tsx): un `useMatch` che rilegge dati non
 * collegati (bicchieri, timer, ...) non deve far scattare/interrompere il lampeggio in corso.
 */
export function nextFlashTarget(previousCount: number | null, rearrangements: readonly { targetTeamId: string }[]): string | null {
  const count = rearrangements.length
  if (previousCount === null || count <= previousCount) return null
  return rearrangements[count - 1].targetTeamId
}
